/* Furniversal, product catalogue (static fallback)
   Generated from data/products.json. The live site reads api/products.php;
   this file is used when that API is not reachable (e.g. the static Vercel host).
   Prices are indicative starting prices in INR and are editable from the admin. */

window.FURNIVERSAL_PRODUCTS = [
  {
    "slug": "bellagio",
    "name": "Bellagio",
    "category": "Sofa Sets",
    "categories": [
      "Sofa Sets"
    ],
    "tagline": "Classic brown leather 3+2 seater set",
    "material": "Full-grain leather",
    "colour": "Cognac Brown",
    "seating": "3 + 2 Seater",
    "price": 215000,
    "dimensions": {
      "w": 225,
      "d": 95,
      "h": 86
    },
    "comfort": "Medium-Firm",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Cognac Brown",
        "hex": "#7A4529"
      }
    ],
    "family": "",
    "description": "The Bellagio brings timeless sophistication to your living room with its rich cognac leather and clean, contemporary lines. A coordinated 3+2 seater set built on a solid hardwood frame and finished with high-resilience foam for support that lasts.",
    "features": [
      "Full-grain Italian leather upholstery",
      "Kiln-dried solid hardwood frame",
      "High-resilience moulded foam seating",
      "Available as 3-seater, 2-seater or full set"
    ],
    "images": [
      "assets/img/products/bellagio/01.jpg",
      "assets/img/products/bellagio/02.jpg",
      "assets/img/products/bellagio/03.jpg"
    ],
    "videos": []
  },
  {
    "slug": "callum",
    "name": "Callum",
    "category": "Sofa Sets",
    "categories": [
      "Sofa Sets"
    ],
    "tagline": "Rolled-arm tan leather lounge set",
    "material": "Aniline leather",
    "colour": "Tan",
    "seating": "3 + 2 Seater",
    "price": 225000,
    "dimensions": {
      "w": 222,
      "d": 98,
      "h": 90
    },
    "comfort": "Soft",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Tan",
        "hex": "#B0713F"
      }
    ],
    "family": "",
    "description": "Callum pairs traditional rolled arms with a warm tan leather finish for a sofa set that feels instantly welcoming. Deep, generous cushions make it the natural centre of any family living space.",
    "features": [
      "Soft aniline leather with natural grain",
      "Classic rolled-arm silhouette",
      "Pocket-spring seat construction",
      "Hand-finished timber feet"
    ],
    "images": [
      "assets/img/products/callum/01.jpg",
      "assets/img/products/callum/02.jpg"
    ],
    "videos": [
      {
        "src": "assets/video/products/callum/01.mp4",
        "poster": "assets/video/products/callum/01.jpg"
      }
    ]
  },
  {
    "slug": "clara",
    "name": "Clara",
    "category": "Sofas",
    "categories": [
      "Sofas"
    ],
    "tagline": "Cognac sofa with adjustable headrests",
    "material": "Top-grain leather",
    "colour": "Cognac",
    "seating": "3 Seater",
    "price": 145000,
    "dimensions": {
      "w": 218,
      "d": 96,
      "h": 92
    },
    "comfort": "Medium",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Cognac",
        "hex": "#9A5330"
      }
    ],
    "family": "",
    "description": "Sleek and modern, the Clara features adjustable headrests and slim metal legs for an elevated, contemporary stance. Perfect for design-led homes that want comfort without bulk.",
    "features": [
      "Adjustable ratchet headrests",
      "Slim powder-coated metal legs",
      "Top-grain leather seating surfaces",
      "Channel-stitched back detailing"
    ],
    "images": [
      "assets/img/products/clara/01.jpg",
      "assets/img/products/clara/02.jpg",
      "assets/img/products/clara/03.jpg"
    ],
    "videos": []
  },
  {
    "slug": "cloudoo",
    "name": "Cloudoo",
    "category": "Sectionals",
    "categories": [
      "Sectionals"
    ],
    "tagline": "Plush bouclé corner sectional",
    "material": "Bouclé fabric",
    "colour": "Ivory",
    "seating": "Corner / L-Shape",
    "price": 245000,
    "dimensions": {
      "w": 300,
      "d": 180,
      "h": 82
    },
    "comfort": "Soft",
    "configs": [
      "Corner L-Shape (LHS)",
      "Corner L-Shape (RHS)",
      "Sectional",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Ivory",
        "hex": "#EDE6D6"
      }
    ],
    "family": "",
    "description": "Soft, cloud-like and impossibly cosy, the Cloudoo sectional wraps a room in plush ivory bouclé. Rounded forms and a deep corner make it ideal for relaxed, sink-in evenings.",
    "features": [
      "Textured bouclé upholstery",
      "Deep corner chaise configuration",
      "Feather-blend back cushions",
      "Removable, washable covers"
    ],
    "images": [
      "assets/img/products/cloudoo/01.jpg",
      "assets/img/products/cloudoo/02.jpg",
      "assets/img/products/cloudoo/03.jpg"
    ],
    "videos": [
      {
        "src": "assets/video/products/cloudoo/01.mp4",
        "poster": "assets/video/products/cloudoo/01.jpg"
      }
    ]
  },
  {
    "slug": "dundee",
    "name": "Dundee",
    "category": "Sofas",
    "categories": [
      "Sofas"
    ],
    "tagline": "Tan leather sofa with channel tufting",
    "material": "Full-grain leather",
    "colour": "Caramel Tan",
    "seating": "3 Seater",
    "price": 180000,
    "dimensions": {
      "w": 220,
      "d": 94,
      "h": 84
    },
    "comfort": "Medium",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Caramel Tan",
        "hex": "#B67A45"
      }
    ],
    "family": "",
    "description": "The Dundee balances mid-century warmth with modern proportions. Channel-tufted cushions in caramel leather sit on tapered legs, making it a versatile statement for living and lounge spaces.",
    "features": [
      "Channel-tufted seat and back",
      "Full-grain caramel leather",
      "Tapered solid-wood legs",
      "Sustainably sourced hardwood frame"
    ],
    "images": [
      "assets/img/products/dundee/01.jpg",
      "assets/img/products/dundee/02.jpg",
      "assets/img/products/dundee/03.jpg",
      "assets/img/products/dundee/04.jpg"
    ],
    "videos": []
  },
  {
    "slug": "estonia",
    "name": "Estonia",
    "category": "Sectionals",
    "categories": [
      "Sectionals"
    ],
    "tagline": "Leather chaise sectional",
    "material": "Top-grain leather",
    "colour": "Tan",
    "seating": "Chaise / L-Shape",
    "price": 255000,
    "dimensions": {
      "w": 290,
      "d": 170,
      "h": 88
    },
    "comfort": "Medium",
    "configs": [
      "Chaise L-Shape (LHS)",
      "Chaise L-Shape (RHS)",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Tan",
        "hex": "#B0713F"
      }
    ],
    "family": "",
    "description": "Estonia offers a relaxed L-shape with a generous chaise, perfect for stretching out. Low arms and a clean leather body give it a refined, architectural presence.",
    "features": [
      "Extended chaise lounge",
      "Top-grain tan leather",
      "Slim metal feet",
      "Reversible chaise orientation"
    ],
    "images": [
      "assets/img/products/estonia/01.jpg",
      "assets/img/products/estonia/02.jpg",
      "assets/img/products/estonia/03.jpg"
    ],
    "videos": [
      {
        "src": "assets/video/products/estonia/01.mp4",
        "poster": "assets/video/products/estonia/01.jpg"
      },
      {
        "src": "assets/video/products/estonia/02.mp4",
        "poster": "assets/video/products/estonia/02.jpg"
      }
    ]
  },
  {
    "slug": "fritz",
    "name": "Fritz",
    "category": "Sofa Sets",
    "categories": [
      "Sofa Sets"
    ],
    "tagline": "Forest-green leather 3+2 set",
    "material": "Full-grain leather",
    "colour": "Forest Green",
    "seating": "3 + 2 Seater",
    "price": 235000,
    "dimensions": {
      "w": 224,
      "d": 96,
      "h": 88
    },
    "comfort": "Medium-Firm",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Forest Green",
        "hex": "#2F4A3A"
      }
    ],
    "family": "",
    "description": "Make a confident statement with Fritz. Deep forest-green leather and sculpted backrests bring a sense of heritage luxury, while the coordinated set anchors the whole room.",
    "features": [
      "Rich forest-green full-grain leather",
      "Sculpted high-support backrests",
      "Coordinated 3+2 seater set",
      "Black tapered metal legs"
    ],
    "images": [
      "assets/img/products/fritz/01.jpg",
      "assets/img/products/fritz/02.jpg",
      "assets/img/products/fritz/03.jpg",
      "assets/img/products/fritz/04.jpg"
    ],
    "videos": [
      {
        "src": "assets/video/products/fritz/01.mp4",
        "poster": "assets/video/products/fritz/01.jpg"
      }
    ]
  },
  {
    "slug": "gemma",
    "name": "Gemma",
    "category": "Sectionals",
    "categories": [
      "Sectionals"
    ],
    "tagline": "Olive bouclé curved sectional",
    "material": "Bouclé fabric",
    "colour": "Olive",
    "seating": "Curved / L-Shape",
    "price": 265000,
    "dimensions": {
      "w": 310,
      "d": 175,
      "h": 80
    },
    "comfort": "Soft",
    "configs": [
      "Curved L-Shape (LHS)",
      "Curved L-Shape (RHS)",
      "Sectional",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Olive",
        "hex": "#6B6B4A"
      }
    ],
    "family": "",
    "description": "Gemma's softly curved silhouette and olive bouclé texture bring organic calm to modern interiors. A sociable, enveloping sectional designed to be the heart of the home.",
    "features": [
      "Curved organic-modern form",
      "Olive textured bouclé",
      "Deep, sink-in seat cushions",
      "Coordinating scatter cushions included"
    ],
    "images": [
      "assets/img/products/gemma/01.jpg",
      "assets/img/products/gemma/02.jpg",
      "assets/img/products/gemma/03.jpg"
    ],
    "videos": []
  },
  {
    "slug": "lola",
    "name": "Lola",
    "category": "Recliners",
    "categories": [
      "Recliners"
    ],
    "tagline": "Cream leather reclining sofa",
    "material": "Top-grain leather",
    "colour": "Cream",
    "seating": "3 Seater Recliner",
    "price": 195000,
    "dimensions": {
      "w": 228,
      "d": 100,
      "h": 102
    },
    "comfort": "Soft",
    "configs": [
      "3 Seater Recliner",
      "2 Seater Recliner",
      "Single Recliner",
      "3+2 Recliner Set"
    ],
    "colours": [
      {
        "name": "Cream",
        "hex": "#EDE3D0"
      }
    ],
    "family": "",
    "description": "Lola combines clean Scandinavian lines with hidden reclining comfort. Smooth cream leather and adjustable headrests make it as practical as it is elegant.",
    "features": [
      "Smooth-glide recline mechanism",
      "Adjustable headrests",
      "Cream top-grain leather",
      "Slim, space-saving footprint",
      "Available with power recline, USB port & child lock"
    ],
    "images": [
      "assets/img/products/lola/01.jpg",
      "assets/img/products/lola/02.jpg",
      "assets/img/products/lola/03.jpg",
      "assets/img/products/lola/04.jpg"
    ],
    "videos": [
      {
        "src": "assets/video/products/lola/01.mp4",
        "poster": "assets/video/products/lola/01.jpg"
      },
      {
        "src": "assets/video/products/lola/02.mp4",
        "poster": "assets/video/products/lola/02.jpg"
      },
      {
        "src": "assets/video/products/lola/03.mp4",
        "poster": "assets/video/products/lola/03.jpg"
      },
      {
        "src": "assets/video/products/lola/04.mp4",
        "poster": "assets/video/products/lola/04.jpg"
      }
    ]
  },
  {
    "slug": "mondarin",
    "name": "Mondarin",
    "category": "Recliners",
    "categories": [
      "Recliners"
    ],
    "tagline": "Modern reclining sofa in ivory",
    "material": "Top-grain leather",
    "colour": "Ivory",
    "seating": "3 Seater Recliner",
    "price": 205000,
    "dimensions": {
      "w": 226,
      "d": 100,
      "h": 100
    },
    "comfort": "Medium",
    "configs": [
      "3 Seater Recliner",
      "2 Seater Recliner",
      "3+2 Recliner Set"
    ],
    "colours": [
      {
        "name": "Ivory",
        "hex": "#F0EADB"
      }
    ],
    "family": "",
    "description": "The Mondarin offers effortless lounging with a refined ivory finish. Powered recline and a low, contemporary stance make it a quiet luxury for the modern living room.",
    "features": [
      "Smooth reclining seats",
      "Ivory top-grain leather",
      "Low contemporary profile",
      "Reinforced hardwood frame",
      "Available with power recline, USB port & child lock"
    ],
    "images": [
      "assets/img/products/mondarin/01.jpg",
      "assets/img/products/mondarin/02.jpg",
      "assets/img/products/mondarin/03.jpg"
    ],
    "videos": [
      {
        "src": "assets/video/products/mondarin/01.mp4",
        "poster": "assets/video/products/mondarin/01.jpg"
      },
      {
        "src": "assets/video/products/mondarin/02.mp4",
        "poster": "assets/video/products/mondarin/02.jpg"
      },
      {
        "src": "assets/video/products/mondarin/03.mp4",
        "poster": "assets/video/products/mondarin/03.jpg"
      }
    ]
  },
  {
    "slug": "mystica",
    "name": "Mystica",
    "category": "Sofas",
    "categories": [
      "Sofas"
    ],
    "tagline": "Curved bouclé statement sofa",
    "material": "Bouclé fabric",
    "colour": "Oat",
    "seating": "3 Seater",
    "price": 165000,
    "dimensions": {
      "w": 232,
      "d": 102,
      "h": 80
    },
    "comfort": "Soft",
    "configs": [
      "3 Seater",
      "2 Seater",
      "Armchair",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Oat",
        "hex": "#D9CDB5"
      }
    ],
    "family": "",
    "description": "Mystica is sculpture for your living room. Soft rounded arms and pillowy bouclé in a warm oat tone make it a tactile, design-forward centrepiece.",
    "features": [
      "Sculptural rounded arms",
      "Plush oat bouclé upholstery",
      "Curved bolster back cushions",
      "Hidden low base for a floating look"
    ],
    "images": [
      "assets/img/products/mystica/01.jpg",
      "assets/img/products/mystica/02.jpg",
      "assets/img/products/mystica/03.jpg",
      "assets/img/products/mystica/04.jpg"
    ],
    "videos": []
  },
  {
    "slug": "orion",
    "name": "Orion",
    "category": "Beds",
    "categories": [
      "Beds"
    ],
    "tagline": "Upholstered bed with tufted headboard",
    "material": "Linen-blend fabric",
    "colour": "Ivory",
    "seating": "Queen / King",
    "price": 115000,
    "dimensions": {
      "w": 168,
      "d": 218,
      "h": 120
    },
    "comfort": "Medium",
    "configs": [
      "Queen 60x78 in",
      "King 72x78 in",
      "Custom size",
      "With storage"
    ],
    "colours": [
      {
        "name": "Ivory",
        "hex": "#F0EADB"
      }
    ],
    "family": "",
    "description": "The Orion bed pairs a softly tufted headboard with a clean upholstered base for a serene, hotel-suite feel. A calm foundation for the perfect bedroom.",
    "features": [
      "Grid-tufted upholstered headboard",
      "Linen-blend fabric",
      "Sturdy slatted base",
      "Available in Queen and King"
    ],
    "images": [
      "assets/img/products/orion/01.jpg",
      "assets/img/products/orion/02.jpg",
      "assets/img/products/orion/03.jpg",
      "assets/img/products/orion/04.jpg"
    ],
    "videos": []
  },
  {
    "slug": "peyton",
    "name": "Peyton",
    "category": "Armchairs",
    "categories": [
      "Armchairs"
    ],
    "tagline": "Sculpted leather accent armchair",
    "material": "Top-grain leather",
    "colour": "Greige",
    "seating": "Single Seater",
    "price": 58000,
    "dimensions": {
      "w": 92,
      "d": 90,
      "h": 84
    },
    "comfort": "Medium",
    "configs": [
      "Single Seater",
      "Pair of two"
    ],
    "colours": [
      {
        "name": "Greige",
        "hex": "#A69B8E"
      }
    ],
    "family": "",
    "description": "Peyton is the perfect reading-corner companion, a sculpted swivel armchair in soft greige leather that adds quiet sophistication to any space.",
    "features": [
      "Sculpted high-comfort shell",
      "360° swivel base",
      "Soft greige top-grain leather",
      "Compact accent footprint"
    ],
    "images": [
      "assets/img/products/peyton/01.jpg",
      "assets/img/products/peyton/02.jpg"
    ],
    "videos": [
      {
        "src": "assets/video/products/peyton/01.mp4",
        "poster": "assets/video/products/peyton/01.jpg"
      },
      {
        "src": "assets/video/products/peyton/02.mp4",
        "poster": "assets/video/products/peyton/02.jpg"
      }
    ]
  },
  {
    "slug": "ski",
    "name": "Ski",
    "category": "Sofa Sets",
    "categories": [
      "Sofa Sets"
    ],
    "tagline": "Emerald-green leather 3+2 set",
    "material": "Full-grain leather",
    "colour": "Emerald Green",
    "seating": "3 + 2 Seater",
    "price": 225000,
    "dimensions": {
      "w": 220,
      "d": 95,
      "h": 86
    },
    "comfort": "Medium-Firm",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Emerald Green",
        "hex": "#1F5F4A"
      }
    ],
    "family": "",
    "description": "Ski brings bold character with deep emerald leather and crisp tailoring. A coordinated set that turns the living room into a confident, design-led space.",
    "features": [
      "Deep emerald full-grain leather",
      "Crisp tailored stitching",
      "Coordinated 3+2 seater set",
      "Slim black metal legs"
    ],
    "images": [
      "assets/img/products/ski/01.jpg",
      "assets/img/products/ski/02.jpg"
    ],
    "videos": [
      {
        "src": "assets/video/products/ski/01.mp4",
        "poster": "assets/video/products/ski/01.jpg"
      },
      {
        "src": "assets/video/products/ski/02.mp4",
        "poster": "assets/video/products/ski/02.jpg"
      }
    ]
  },
  {
    "slug": "tanglin",
    "name": "Tanglin",
    "category": "Sectionals",
    "categories": [
      "Sectionals"
    ],
    "tagline": "Modular fabric L-sectional",
    "material": "Performance fabric",
    "colour": "Sand",
    "seating": "Modular / L-Shape",
    "price": 235000,
    "dimensions": {
      "w": 305,
      "d": 175,
      "h": 84
    },
    "comfort": "Medium",
    "configs": [
      "Modular L-Shape",
      "Sectional",
      "Chaise add-on",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Sand",
        "hex": "#CDBB9A"
      }
    ],
    "family": "",
    "description": "Tanglin is built for modern living, a modular sand-toned sectional with adjustable backs and a deep chaise. Configure it to fit your space and your lifestyle.",
    "features": [
      "Modular, reconfigurable layout",
      "Adjustable reclining backrests",
      "Stain-resistant performance fabric",
      "Deep lounging chaise"
    ],
    "images": [
      "assets/img/products/tanglin/01.jpg",
      "assets/img/products/tanglin/02.jpg",
      "assets/img/products/tanglin/03.jpg",
      "assets/img/products/tanglin/04.jpg",
      "assets/img/products/tanglin/05.jpg"
    ],
    "videos": []
  },
  {
    "slug": "willow",
    "name": "Willow",
    "category": "Sofas",
    "categories": [
      "Sofas"
    ],
    "tagline": "Curved bouclé loveseat pair",
    "material": "Bouclé fabric",
    "colour": "Cream",
    "seating": "2 Seater",
    "price": 98000,
    "dimensions": {
      "w": 160,
      "d": 92,
      "h": 78
    },
    "comfort": "Soft",
    "configs": [
      "2 Seater",
      "Pair of two",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Cream",
        "hex": "#EDE6D6"
      }
    ],
    "family": "",
    "description": "Willow's gently curved form and creamy bouclé create an inviting, conversational seating piece. Beautiful solo or styled as a coordinating pair.",
    "features": [
      "Soft curved silhouette",
      "Cream bouclé upholstery",
      "Solid timber plinth base",
      "Pairs beautifully in twos"
    ],
    "images": [
      "assets/img/products/willow/01.jpg",
      "assets/img/products/willow/02.jpg",
      "assets/img/products/willow/03.jpg",
      "assets/img/products/willow/04.jpg"
    ],
    "videos": []
  },
  {
    "slug": "dreamzy",
    "name": "Dreamzy",
    "category": "Beds",
    "categories": [
      "Beds"
    ],
    "tagline": "Curved bouclé upholstered bed",
    "material": "Bouclé fabric",
    "colour": "Cream",
    "seating": "Queen / King",
    "price": 125000,
    "dimensions": {
      "w": 175,
      "d": 225,
      "h": 105
    },
    "comfort": "Medium",
    "configs": [
      "Queen 60x78 in",
      "King 72x78 in",
      "Custom size",
      "With storage"
    ],
    "colours": [
      {
        "name": "Cream",
        "hex": "#EDE6D6"
      }
    ],
    "family": "",
    "description": "Dreamzy is the bedroom dream, a softly curved bouclé headboard and plush upholstered base that wrap your space in cosy, contemporary calm.",
    "features": [
      "Curved sculptural headboard",
      "Plush cream bouclé",
      "Upholstered full surround base",
      "Available in Queen and King"
    ],
    "images": [
      "assets/img/products/dreamzy/01.jpg",
      "assets/img/products/dreamzy/02.jpg",
      "assets/img/products/dreamzy/03.jpg"
    ],
    "videos": []
  },
  {
    "slug": "kendra",
    "name": "Kendra",
    "category": "Sofa Sets",
    "categories": [
      "Sofa Sets"
    ],
    "tagline": "Cognac leather living set",
    "material": "Full-grain leather",
    "colour": "Cognac",
    "seating": "3 + 2 Seater",
    "price": 215000,
    "dimensions": {
      "w": 222,
      "d": 96,
      "h": 84
    },
    "comfort": "Medium",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Cognac",
        "hex": "#8B4A2B"
      }
    ],
    "family": "",
    "description": "Kendra delivers understated luxury with warm cognac leather, clean low arms and a coordinated set that feels equally at home in grand and intimate spaces.",
    "features": [
      "Warm cognac full-grain leather",
      "Low contemporary arms",
      "Coordinated 3+2 seater set",
      "Solid hardwood frame"
    ],
    "images": [
      "assets/img/products/kendra/01.jpg",
      "assets/img/products/kendra/02.jpg",
      "assets/img/products/kendra/03.jpg",
      "assets/img/products/kendra/04.jpg",
      "assets/img/products/kendra/05.jpg"
    ],
    "videos": []
  },
  {
    "slug": "oasis",
    "name": "Oasis",
    "category": "Beds",
    "categories": [
      "Beds"
    ],
    "tagline": "Camel leather upholstered bed",
    "material": "Top-grain leather",
    "colour": "Camel",
    "seating": "Queen / King",
    "price": 135000,
    "dimensions": {
      "w": 178,
      "d": 226,
      "h": 110
    },
    "comfort": "Medium",
    "configs": [
      "Queen 60x78 in",
      "King 72x78 in",
      "Custom size",
      "With storage"
    ],
    "colours": [
      {
        "name": "Camel",
        "hex": "#B58B5A"
      }
    ],
    "family": "",
    "description": "Oasis brings warmth to the bedroom with a panelled camel-leather headboard and clean upholstered base. A rich, grounding centrepiece for restful nights.",
    "features": [
      "Panelled camel-leather headboard",
      "Full upholstered surround",
      "Sturdy slatted support base",
      "Available in Queen and King"
    ],
    "images": [
      "assets/img/products/oasis/01.jpg",
      "assets/img/products/oasis/02.jpg",
      "assets/img/products/oasis/03.jpg"
    ],
    "videos": []
  },
  {
    "slug": "sherman",
    "name": "Sherman",
    "category": "Sofas",
    "categories": [
      "Sofas"
    ],
    "tagline": "Curved bouclé comfort sofa",
    "material": "Bouclé fabric",
    "colour": "Ivory",
    "seating": "3 Seater",
    "price": 155000,
    "dimensions": {
      "w": 226,
      "d": 104,
      "h": 82
    },
    "comfort": "Soft",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Ivory",
        "hex": "#F0EADB"
      }
    ],
    "family": "",
    "description": "Sherman is all about soft, rounded comfort. Deep seats and plush ivory bouclé make it the perfect spot to unwind in style.",
    "features": [
      "Deep rounded seating",
      "Ivory textured bouclé",
      "Curved arm-to-seat form",
      "Slim tapered metal feet"
    ],
    "images": [
      "assets/img/products/sherman/01.jpg",
      "assets/img/products/sherman/02.jpg",
      "assets/img/products/sherman/03.jpg"
    ],
    "videos": [
      {
        "src": "assets/video/products/sherman/01.mp4",
        "poster": "assets/video/products/sherman/01.jpg"
      },
      {
        "src": "assets/video/products/sherman/02.mp4",
        "poster": "assets/video/products/sherman/02.jpg"
      }
    ]
  },
  {
    "slug": "detroit",
    "name": "Detroit",
    "category": "Sofa Sets",
    "categories": [
      "Sofa Sets"
    ],
    "tagline": "Two-tone fabric & leather 3+2 set",
    "material": "Textured fabric with leather trim",
    "colour": "Beige & Tan",
    "seating": "3 + 2 Seater",
    "price": 198000,
    "dimensions": {
      "w": 220,
      "d": 95,
      "h": 86
    },
    "comfort": "Medium",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Beige & Tan",
        "hex": "#C9B99B"
      }
    ],
    "family": "",
    "description": "Detroit blends soft patterned fabric seating with warm tan leather arms and base for a contemporary two-tone statement. The coordinated 3+2 set brings texture, contrast and everyday comfort to the modern living room.",
    "features": [
      "Two-tone fabric and leather upholstery",
      "Patterned chenille seating panels",
      "Tan leather-wrapped arms and base",
      "Coordinated 3+2 seater set on black metal legs"
    ],
    "images": [
      "assets/img/products/detroit/01.jpg",
      "assets/img/products/detroit/02.jpg"
    ],
    "videos": []
  },
  {
    "slug": "milano",
    "name": "Milano",
    "category": "Sectionals",
    "categories": [
      "Sectionals"
    ],
    "tagline": "Taupe leather chaise sectional with pushback backs",
    "material": "Top-grain leather",
    "colour": "Taupe",
    "seating": "Chaise / L-Shape",
    "price": 245000,
    "dimensions": {
      "w": 285,
      "d": 168,
      "h": 86
    },
    "comfort": "Medium",
    "configs": [
      "Chaise L-Shape (LHS)",
      "Chaise L-Shape (RHS)",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Taupe",
        "hex": "#8C7B6B"
      }
    ],
    "family": "",
    "description": "Milano pairs a clean L-shape and generous chaise with clever pushback backrests, so you sit upright for conversation, then gently push back for deep relaxation. Smooth taupe leather and slim metal feet keep it effortlessly modern.",
    "features": [
      "Adjustable pushback backrests",
      "Extended lounging chaise",
      "Smooth taupe top-grain leather",
      "Slim tapered metal feet"
    ],
    "images": [
      "assets/img/products/milano/01.jpg",
      "assets/img/products/milano/02.jpg"
    ],
    "videos": []
  },
  {
    "slug": "nexus",
    "name": "Nexus",
    "category": "Sofa Sets",
    "categories": [
      "Sofa Sets"
    ],
    "tagline": "Burnt-orange button-tufted leather 3+2 set",
    "material": "Full-grain leather",
    "colour": "Rust / Burnt Orange",
    "seating": "3 + 2 Seater",
    "price": 228000,
    "dimensions": {
      "w": 224,
      "d": 98,
      "h": 90
    },
    "comfort": "Medium-Firm",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Rust / Burnt Orange",
        "hex": "#B4552F"
      }
    ],
    "family": "",
    "description": "Nexus makes a bold, characterful statement with rich rust leather and a diamond button-tufted backrest. Curved rolled arms and slim black legs give this coordinated 3+2 set a refined, retro-modern presence.",
    "features": [
      "Diamond button-tufted backrest",
      "Rich burnt-orange full-grain leather",
      "Curved rolled arms",
      "Coordinated 3+2 seater set on black metal legs"
    ],
    "images": [
      "assets/img/products/nexus/01.jpg",
      "assets/img/products/nexus/02.jpg",
      "assets/img/products/nexus/03.jpg"
    ],
    "videos": []
  },
  {
    "slug": "nova",
    "name": "Nova",
    "category": "Sofa Sets",
    "categories": [
      "Sofa Sets"
    ],
    "tagline": "Plush oatmeal fabric 3+2 set with pushback backs",
    "material": "Textured fabric",
    "colour": "Oatmeal Beige",
    "seating": "3 + 2 Seater",
    "price": 175000,
    "dimensions": {
      "w": 222,
      "d": 98,
      "h": 92
    },
    "comfort": "Soft",
    "configs": [
      "3 Seater",
      "2 Seater",
      "3+2 Set",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Oatmeal Beige",
        "hex": "#D9CDB5"
      }
    ],
    "family": "",
    "description": "Nova wraps the room in soft, pillowy comfort. Deep oatmeal fabric seats and rounded forms invite you to sink in, while the pushback backrests adjust from upright to fully relaxed. A cosy, sociable 3+2 set for modern homes.",
    "features": [
      "Adjustable pushback backrests",
      "Plush pillow-top seats and back",
      "Soft textured oatmeal fabric",
      "Coordinated 3+2 seater set"
    ],
    "images": [
      "assets/img/products/nova/01.jpg",
      "assets/img/products/nova/02.jpg"
    ],
    "videos": []
  },
  {
    "slug": "quinn",
    "name": "Quinn",
    "category": "Recliners",
    "categories": [
      "Recliners"
    ],
    "tagline": "Sand leather power-recliner set",
    "material": "Top-grain leather",
    "colour": "Sand",
    "seating": "3 + 2 Power Recliner",
    "price": 265000,
    "dimensions": {
      "w": 230,
      "d": 102,
      "h": 104
    },
    "comfort": "Soft",
    "configs": [
      "3+2 Power Recliner Set",
      "3 Seater Power Recliner",
      "2 Seater Power Recliner"
    ],
    "colours": [
      {
        "name": "Sand",
        "hex": "#C8B28F"
      }
    ],
    "family": "",
    "description": "Quinn brings cinema-style comfort home with smooth powered recline at the touch of a button. Warm sand leather, padded arms and a coordinated 3+2 set make it the effortless centrepiece of a relaxed living space.",
    "features": [
      "One-touch power recline",
      "Warm sand top-grain leather",
      "Padded pillow-top arms",
      "Coordinated 3+2 seater recliner set",
      "Double-motor power recline (back & footrest)",
      "USB charging ports in the arms",
      "Child-lock safety"
    ],
    "images": [
      "assets/img/products/quinn/01.jpg",
      "assets/img/products/quinn/02.jpg"
    ],
    "videos": []
  },
  {
    "slug": "serenova",
    "name": "Serenova",
    "category": "Sectionals",
    "categories": [
      "Sectionals"
    ],
    "tagline": "Cream bouclé corner sectional with console",
    "material": "Bouclé fabric",
    "colour": "Cream",
    "seating": "Corner / L-Shape",
    "price": 258000,
    "dimensions": {
      "w": 300,
      "d": 182,
      "h": 84
    },
    "comfort": "Soft",
    "configs": [
      "Corner L-Shape (LHS)",
      "Corner L-Shape (RHS)",
      "With console",
      "Custom size"
    ],
    "colours": [
      {
        "name": "Cream",
        "hex": "#EDE6D6"
      }
    ],
    "family": "",
    "description": "Serenova is soft, serene and built for togetherness, a plush cream bouclé corner sectional with rolled arms and a built-in cup-holder console. Deep seats and a generous corner make it the perfect spot to gather and unwind.",
    "features": [
      "Plush textured bouclé upholstery",
      "Spacious corner L-shape layout",
      "Built-in storage & cup-holder console",
      "Rounded rolled arms with deep seats"
    ],
    "images": [
      "assets/img/products/serenova/01.jpg",
      "assets/img/products/serenova/02.jpg",
      "assets/img/products/serenova/03.jpg"
    ],
    "videos": []
  },
  {
    "slug": "valencia",
    "name": "Valencia",
    "category": "Sectionals",
    "categories": [
      "Sectionals"
    ],
    "tagline": "Cognac leather corner reclining sectional",
    "material": "Top-grain leather",
    "colour": "Cognac Tan",
    "seating": "Corner Recliner / L-Shape",
    "price": 275000,
    "dimensions": {
      "w": 295,
      "d": 178,
      "h": 100
    },
    "comfort": "Medium",
    "configs": [
      "Corner Recliner L-Shape (LHS)",
      "Corner Recliner L-Shape (RHS)",
      "With console"
    ],
    "colours": [
      {
        "name": "Cognac Tan",
        "hex": "#A9683B"
      }
    ],
    "family": "",
    "description": "Valencia is the ultimate lounging sectional, a rich cognac leather corner suite with built-in recliners and a handy cup-holder console. Warm, tailored and endlessly comfortable, it turns any living room into a home cinema retreat.",
    "features": [
      "Built-in reclining seats",
      "Rich cognac top-grain leather",
      "Corner L-shape with cup-holder console",
      "Padded headrests and arms",
      "USB charging port & child-lock safety",
      "Available with double-motor power recline"
    ],
    "images": [
      "assets/img/products/valencia/01.jpg",
      "assets/img/products/valencia/02.jpg",
      "assets/img/products/valencia/03.jpg"
    ],
    "videos": []
  },
  {
    "slug": "zenith",
    "name": "Zenith",
    "category": "Recliners",
    "categories": [
      "Recliners"
    ],
    "tagline": "Taupe leather power-recliner set",
    "material": "Top-grain leather",
    "colour": "Taupe",
    "seating": "3 + 2 Power Recliner",
    "price": 265000,
    "dimensions": {
      "w": 230,
      "d": 102,
      "h": 104
    },
    "comfort": "Medium",
    "configs": [
      "3+2 Power Recliner Set",
      "3 Seater Power Recliner",
      "2 Seater Power Recliner"
    ],
    "colours": [
      {
        "name": "Taupe",
        "hex": "#8C7B6B"
      }
    ],
    "family": "",
    "description": "Zenith delivers plush, upright comfort with pillowy padded backs and one-touch powered recline. Neutral taupe leather and a coordinated 3+2 set make it a versatile, easy-living choice for the whole family.",
    "features": [
      "One-touch power recline",
      "Pillow-padded backs and arms",
      "Neutral taupe top-grain leather",
      "Coordinated 3+2 seater recliner set",
      "Double-motor power recline (back & footrest)",
      "USB charging ports in the arms",
      "Child-lock safety"
    ],
    "images": [
      "assets/img/products/zenith/01.jpg"
    ],
    "videos": []
  }
];

window.FURNIVERSAL_CATEGORIES = ["Sofa Sets","Sofas","Sectionals","Recliners","Beds","Armchairs","Home Theatres","Puffies","Sofa-cum-Beds","Dining Tables","Centre & Side Tables"];
